// src/components/Toast.jsx
export default function Toast({ message, type, onClose }) {
  return (
    <div className={`toast toast--${type}`}>
      <span>{message}</span>
      <button
        onClick={onClose}
        style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: '#686779' }}
      >
        ×
      </button>
    </div>
  );
}